import { Alert, AlertTitle } from '@mui/material'

import { useController } from '../../../hooks/useController'
import { useTexts } from '../useTexts'

export function ErrorBody() {
  const {
    data: {
      values: { notificationWay },
    },
  } = useController()

  const texts = useTexts()
  if (!notificationWay) return null

  return (
    <Alert severity="error" icon={false}>
      <AlertTitle>{texts.getErrorTitle(notificationWay)}</AlertTitle>
      {texts.getErrorDescription(notificationWay)}
    </Alert>
  )
}
